import paths, { rootPaths } from './paths';
import * as accessControlObj from '../components/authentication/accessControlMap';

var localStorageAccessControl = localStorage.getItem("accessControl");
if (localStorageAccessControl === null) {
  localStorageAccessControl = [];
} else {
  localStorageAccessControl = localStorageAccessControl.split(",");
}


// convert each localStorageAccessControl element to integer
localStorageAccessControl = localStorageAccessControl.map(function(item) {
  return parseFloat(item);
  // return parseInt(item, 10);
});


// import * as accessControlObj from '../components/authentication/accessControlMap';

// var localStorageAccessControl = localStorage.getItem("accessControl");

// let defaultRoutes = [];
// let roleId = localStorage.getItem("roleId");
//console.log("siteMap " + localStorage.getItem("roleId"));
export const dashboardRoutes = {
  label: 'Dashboard',
  labelDisable: true,
  children: [
    {
      name: 'Dashboard',
      active: false,
      icon: 'chart-pie'
      /*children: [
        {
          name: 'Default',
          to: rootPaths.dashboardRoot,
          exact: true,
          active: true
        }
      ]*/
    }
  ]
};

export const patientRoutes = {
  label: 'Patient',
  children: [
    {
      name: 'View Patient Info',
      icon: 'hospital-user',
      to: paths.viewPatient,
      active: true
    },
    {
      name: 'View Day Program Patients',
      icon: 'hospital-user',
      to: paths.viewDayProgramPatients,
      active: true
    },
    {
      name: 'Add Patient',
      icon: 'user-plus',
      to: paths.addPatient,
      active: true
    },
  ]
};

export const reportRoutes = {
  label: 'Facility Reports',
  children: [
    {
      name: 'Reports',
      icon: 'hospital-user',
      active: true,
      children: [
        {
          name: 'Medsheet',
          to: paths.genMedSheet,
          active: true
        },
        {
          name: 'Treatment',
          to: paths.genTreatment,
          active: true
        },
        {
          name: 'CurrentMed',
          to: paths.genCurrentMed,
          active: true
        },
        {
          name: 'Blank Medsheet',
          to: paths.genBlankMed,
          active: true
        },
        {
          name: 'Splitmed Report',
          to: paths.splitmedreport,
          active: true
        },
        {
          name: 'Drug Usage Report',
          to: paths.drugScheduleReport,
          active: true
        },
        {
          name: 'Facility Created Medications',
          to: paths.facilityPrescriptionReport,
          active: true
        },
        {
          name: 'Unverified Prescription Report',
          to: paths.unverifiedReport,
          active: true
        },
        {
          name: 'Facility Side Effect Sheet',
          to: paths.facilitySideEffectSheet,
          active: true
        },
      ]
    }
  ]
};

// SharedLiving caregiver (role 7) sidebar — tightly scoped (UI-033).
// Reports are NOT here: caregivers pull reports per-patient from the patient
// detail page (the Reports tab inside PatientInfo).
export const caregiverRoutes = {
  label: 'SharedLiving',
  children: [
    {
      name: 'My Patients',
      icon: 'hospital-user',
      to: paths.caregiverMyPatients,
      active: true
    },
    {
      name: 'Medpass Dashboard',
      icon: 'mobile',
      to: paths.medpassdashboard,
      active: true
    },
    {
      name: 'Medpass Report',
      icon: 'mobile',
      to: paths.medpassreport,
      active: true
    },
    // {
    //   name: 'Day Program Attendance',
    //   icon: 'calendar-check',
    //   to: paths.dayProgramAttendance,
    //   active: true,
    //   requiresAccess: 'dayprogramactive'
    // }
  ]
};

export const MedpassRoutes  = {
  label: 'Medpass',
  children: [
    {
      name: 'Medpass Report',
      icon: 'mobile',
      to: paths.medpassreport,
      active: true
    },
    {
      name: 'Medpass Dashboard',
      icon: 'mobile',
      to: paths.medpassdashboard,
      active: true
    },
    // {
    //   name: 'Day Program Attendance',
    //   icon: 'calendar-check',
    //   to: paths.dayProgramAttendance,
    //   active: true,
    //   requiresAccess: 'dayprogramactive'
    // }
  ]
};

export const Resources = {
  label: 'Resources',
  children: [
    {
      name: 'MAP Manual',
      icon: 'file',
      active: true,
      to: 'https://www.mass.gov/doc/map-policy-manual-final/download',
      external: true,
      target: '_blank'
    },
    // {
    //   name: 'MAP Certification Curriculum',
    //   icon: 'file',
    //   active: true,
    //   to: 'https://mapmass.com/pluginfile.php/147111/mod_resource/content/1/Responsibilities%20in%20Action_final.pdf',
    //   external: true,
    //   target: '_blank'
    // },
    {
      name: 'Responsibilities in Action',
      icon: 'file',
      active: true,
      to: 'https://mapmass.com/pluginfile.php/21617/mod_page/content/338/Responsibilities%20in%20Action_2025_final_compressed.2.pdf',
      external: true,
      target: '_blank'
    },
  ]
};

export const drugListRoute  = {
  label: 'Drug Master',
  children: [
    {
      name: 'Drug List',
      icon: 'capsules',
      to: paths.drugList,
      active: true
    }
  ]
};

export const prescriptionRoutes = {
  label: 'Prescription',
  children: [
    {
      name: 'Add Prescription',
      icon: 'shopping-cart',
      to: paths.addPrescription,
      active: true
    }
  ]
};

export const hcpRoutes = {
  label: 'HCP',
  children: [
    {
      name: 'Add HCP',
      icon: 'user-md',
      to: paths.addEditHcp,
      active: true
    },
    {
      name: 'View HCP',
      icon: 'user',
      to: paths.viewHcp,
      active: true
    },
    {
      name: 'HCP Speciality',
      icon: 'user',
      to: paths.hcpSpeciality,
      active: true
    }
  ]
};

var allowedReports = [];


// convert accessControlObj.ACCESS_CONTROL["mym"] to string
// accessControlObj.ACCESS_CONTROL["mym"] = acce
// if(localStorageAccessControl.includes(accessControlObj.ACCESS_CONTROL["mym"])) {
//   allowedReports.push({
//     name: 'Medsheet',
//     to: paths.genMedSheet,
//     active: true
//   });
// }

// if(localStorageAccessControl.includes(accessControlObj.ACCESS_CONTROL["mym"])) {
//   allowedReports.push({
//     name: 'Treatment',
//     to: paths.genTreatment,
//     active: true
//   });
// }

// if(localStorageAccessControl.includes(accessControlObj.ACCESS_CONTROL["mym"])) {
//   allowedReports.push({
//     name: 'CurrentMed',
//     to: paths.genCurrentMed,
//     active: true
//   });
// }

// var reportsRoutes = [];
// if(allowedReports.length > 0) {
//   reportsRoutes = [
//     {
//       name: 'Reports',
//       icon: 'file',
//       active: true,
//       children: allowedReports
//     }
//   ]
// }

export const masterRoutes = {
  label: 'Master',
  children: [
    {
      name: 'User Management',
      icon: 'user',
      active: true,
      children: [
        {
          name: 'View User Details',
          to: paths.viewFacility,
          active: true
        },
        {
          name: 'User Registration',
          to: paths.addFacility,
          active: true
        },
        {
          name: 'Users Activity Report',
          to: paths.loggedinReport,
          active: true
        },
        {
          name: 'All Active Sessions',
          to: paths.viewAllActiveSessions,
          active: true
        }
      ]
    },
    {
      name: 'Admin',
      icon: 'asterisk',
      active: true,
      children: [
        {
          name: 'Day Programs',
          to: paths.adminDayPrograms,
          active: true,
          icon: 'heart',
        },
        {
          name: 'Patient',
          to: paths.insurance,
          icon: 'procedures',
          active: true,
          children: [
            {
              name: 'Allergy',
              to: paths.allergy,
              // icon: '<i class="fas fa-allergies"></i>',
              active: true
            },
            {
              name: 'Insurance',
              to: paths.insurance,
              // icon: 'user',
              active: true
            },
            {
              name: 'Insurance Priority',
              to: paths.insurancePriority,
              // icon: 'user',
              active: true
            },
            {
              name: 'Diagnosis',
              to: paths.diseaseCode,
              // icon: 'user',
              active: true
            },
          ]
        },
        {
          name: 'Drugs',
          to: paths.insurance,
          icon: 'capsules',
          active: true,
          children: [
            {
              name: 'Drug List',
              to: paths.drugList,
              // icon: 'user',
              active: true
            },
            {
              name: 'Pharmacy',
              to: paths.pharmacy,
              // icon: 'user',
              active: true
            },
            {
              name: 'MedGroup',
              to: paths.medGroup,
              // icon: 'user',
              active: true
            },
             {
              name: 'Vitals',
              to: paths.vitals,
              // icon: 'user',
              active: true
            }
          ]
        },
        {
          name: 'Prescription',
          to: paths.insurance,
          icon: 'prescription',
          active: true,
          children: [
            {
              name: 'Route',
              to: paths.medRoute,
              // icon: 'user',
              active: true
            },
            {
              name: 'Amount',
              to: paths.medAmount,
              // icon: 'user',
              active: true
            },
            {
              name: 'Frequency',
              to: paths.medFrequency,
              // icon: 'user',
              active: true
            },
            {
              name: 'Special Instruction',
              to: paths.medSplInstr,
              // icon: 'user',
              active: true
            },
            {
              name: 'Reason Prescribed',
              to: paths.medReasonPresc,
              // icon: 'user',
              active: true
            },
            {
              name: 'Hour/HOA',
              to: paths.medHour,
              // icon: 'user',
              active: true
            },
            {
              name: 'Drug Unit',
              to: paths.drugUnit,
              // icon: 'user',
              active: true
            },
            {
              name: 'Medical Record Category',
              to: paths.medRecordCategory,
              // icon: 'user',
              active: true
            },
          ]
        },
        {
          name: 'HCP',
          to: paths.insurance,
          icon: 'stethoscope',
          active: true,
          children: [
            {
              name: 'Add HCP',
              // icon: 'user-md',
              to: paths.addEditHcp,
              active: true
            },
            {
              name: 'View HCP',
              // icon: 'user',
              to: paths.viewHcp,
              active: true
            },
            {
              name: 'HCP Speciality',
              // icon: 'user',
              to: paths.hcpSpeciality,
              active: true
            }
          ]
        },
        // {
        //   name: 'Bulk Import',
        //   icon: 'file-import',
        //   active: true,
        //   children: [
        //     {
        //       name: 'Day Program Patients',
        //       to: paths.importDayProgramPatients,
        //       active: true
        //     }
        //   ]
        // },
      ]
    },
    // {
    //   name: 'Report',
    //   icon: 'user',
    //   active: true,
    //   children: [
    //     {
    //       name: 'Logged in report',
    //       to: paths.loggedinReport,
    //       active: true
    //     },
    //   ]
    // }
    // ...reportsRoutes
  ]
};

export const pharmacyAdminRoutes = {
  label : 'Peltask',
  children: [
    {
      name: 'Groups & Facilities',
      icon: 'file',
      active: true,
      to: paths.faciliityLookUp
    },
    {
      name: 'Hold Reason',
      icon: 'prescription',
      to: paths.holdReason,
      active: true
    }
  ]
};

export const Rout4MeRoutes = {
  label : 'Route4Me',
  children: [
    {
      name: 'Route4Me',
      icon: 'sync-alt',
      active: true,
      children: [
          {
            name: 'Data Transfer',
            to: paths.route4medatatransfer,
            active: true
          },
          {
            name: 'Delivery Status',
            to: paths.route4medeliverystatus,
            active: true
          },
          {
            name: 'Delivery Driver Setup',
            to: paths.route4medeliverydriver,
            active: true
          }
      ]
    }
  ]
};

export const orderHistoryRoutes = {
  label: 'Order',
  children : [
    {
      name: 'Order',
      icon: 'sync-alt',
      active: true,
      children: [
          {
            name: 'Order History',
            to: paths.orderHistoryFacility,
            active: true
          },
          {
            name: 'Refill Reminders',
            to: paths.needrefill,
            active: true
          }
      ]
    }
  ]
};

export const peltaskAdminRoutes = {
  label: 'Cycle',
  children: [
    {
      name: 'Cycle',
      active: true,
      icon: 'sync-alt',
      children: [
        {
          name: 'Cycle View',
          to: paths.cycleView,
          active: true
        },
        {
          name: 'Cycle Detail',
          to: paths.cycleDelivery(),
          active: true
        },
        {
          name: 'Cycle Status',
          to: paths.cycleStatus,
          active: true
        }
      ]
    },
    {
      name: 'Hold',
      active: true,
      icon: 'sync-alt',
      to: paths.indexHold
    },
    {
      name: 'Order List',
      icon: 'sync-alt',
      to: paths.orderDetail,
      active: true
    },
    {
      name: 'Patient-Dashboard',
      icon: 'sync-alt',
      active: true,
      to: paths.orderHistory
    },
    // {
    //   name: 'Orders',
    //   active: true,
    //   icon: 'sync-alt',
    //   children: [
    //     {
    //       name: 'Order List',
    //       icon: 'file',
    //       to: paths.orderDetail,
    //       active: true
    //     },
    //     // {
    //     //   name: 'Patient-View',
    //     //   icon: 'file',
    //     //   active: true,
    //     //   to: paths.orderHistory
    //     // },
    //     // {
    //     //   name: 'Demo',
    //     //   icon: 'file',
    //     //   active: true,
    //     //   to: paths.demofile
    //     // }
    //   ]
    // }
  ]
};

export const peltaskRoutes = {
  label: 'Cycle',
  children: [
    {
      name: 'Cycle',
      to: paths.cycleDelivery(),
      icon: 'sync-alt',
      active: true
    }
  ]
};

export const modulesRoutes = {
  label: 'Modules',
  children: [
    {
      name: 'Forms',
      active: true,
      icon: 'file-alt',
      children: [
        {
          name: 'Basic',
          active: true,
          children: [
            {
              name: 'Form control',
              to: paths.formControl,
              active: true
            },
            {
              name: 'Input group',
              to: paths.inputGroup,
              active: true
            },
            {
              name: 'Select',
              to: paths.select,
              active: true
            },
            {
              name: 'Checks',
              to: paths.checks,
              active: true
            },
            {
              name: 'Range',
              to: paths.range,
              active: true
            },
            {
              name: 'Layout',
              to: paths.formLayout,
              active: true
            }
          ]
        },
        {
          name: 'Advance',
          active: true,
          children: [
            {
              name: 'Advance select',
              to: paths.advanceSelect,
              active: true
            },
            {
              name: 'Date picker',
              to: paths.datePicker,
              active: true
            },
            {
              name: 'Editor',
              to: paths.editor,
              active: true
            },
            {
              name: 'Emoji button',
              to: paths.emojiButton,
              active: true
            },
            {
              name: 'File uploader',
              to: paths.fileUploader,
              active: true
            },
            {
              name: 'Input mask',
              to: paths.inputMask,
              active: true
            },
            {
              name: 'Range slider',
              to: paths.rangeSlider,
              active: true
            },
            {
              name: 'Rating',
              to: paths.rating,
              active: true
            }
          ]
        },
        {
          name: 'Floating labels',
          to: paths.floatingLabels,
          active: true
        },
        {
          name: 'Wizard',
          to: paths.wizard,
          active: true
        },
        {
          name: 'Validation',
          to: paths.validation,
          active: true
        }
      ]
    },
    {
      name: 'Tables',
      icon: 'table',
      active: true,
      children: [
        {
          name: 'Basic tables',
          to: paths.basicTables,
          active: true
        },
        {
          name: 'Advance tables',
          to: paths.advanceTables,
          active: true
        }
      ]
    },
    {
      name: 'Charts',
      icon: 'chart-line',
      active: true,
      children: [
        {
          name: 'Chartjs',
          to: paths.chartjs,
          active: true
        },
        {
          name: 'D3js',
          to: paths.d3js,
          active: true,
          badge: {
            type: 'success',
            text: 'New'
          }
        },
        {
          name: 'ECharts',
          active: true,
          children: [
            {
              name: 'How to use',
              to: paths.echartsHowToUse,
              active: true
            },
            {
              name: 'Line charts',
              to: paths.lineCharts,
              active: true
            },
            {
              name: 'Bar charts',
              to: paths.barCharts,
              active: true
            },
            {
              name: 'Candlestick charts',
              to: paths.candlestickCharts,
              active: true
            },
            {
              name: 'Geo map',
              to: paths.geoMap,
              active: true
            },
            {
              name: 'Scatter charts',
              to: paths.scatterCharts,
              active: true
            },
            {
              name: 'Pie charts',
              to: paths.pieCharts,
              active: true
            },
            {
              name: 'Radar charts',
              to: paths.radarCharts,
              active: true
            },
            {
              name: 'Heatmap charts',
              to: paths.heatmapCharts,
              active: true
            }
          ]
        }
      ]
    },
    {
      name: 'Icons',
      active: true,
      icon: 'shapes',
      children: [
        {
          name: 'Font awesome',
          to: paths.fontAwesome,
          active: true
        },
        {
          name: 'React icons',
          to: paths.reactIcons,
          active: true
        }
      ]
    },
    {
      name: 'Maps',
      icon: 'map',
      active: true,
      children: [
        {
          name: 'Google map',
          to: paths.googleMap,
          active: true
        },
        {
          name: 'Leaflet map',
          to: paths.leafletMap,
          active: true
        }
      ]
    },
    {
      name: 'Components',
      active: true,
      icon: 'puzzle-piece',
      children: [
        {
          name: 'Alerts',
          to: paths.alerts,
          active: true
        },
        {
          name: 'Accordion',
          to: paths.accordion,
          active: true
        },
        {
          name: 'Animated icons',
          to: paths.animatedIcons,
          active: true
        },
        {
          name: 'Backgrounds',
          to: paths.background,
          active: true
        },
        {
          name: 'Badges',
          to: paths.badges,
          active: true
        },
        {
          name: 'Breadcrumbs',
          to: paths.breadcrumbs,
          active: true
        },
        {
          name: 'Buttons',
          to: paths.buttons,
          active: true
        },
        {
          name: 'Calendar',
          to: paths.calendar,
          active: true
        },
        {
          name: 'Cards',
          to: paths.cards,
          active: true
        },
        {
          name: 'Carousel',
          active: true,
          children: [
            {
              name: 'Bootstrap',
              to: paths.bootstrapCarousel,
              label: 'bootstrap-carousel',
              active: true
            },
            {
              name: 'Slick',
              to: paths.slickCarousel,
              active: true
            }
          ]
        },
        {
          name: 'Collapse',
          to: paths.collapse,
          active: true
        },
        {
          name: 'Cookie notice',
          to: paths.cookieNotice,
          active: true
        },
        {
          name: 'Countup',
          to: paths.countup,
          active: true
        },
        {
          name: 'Draggable',
          to: paths.draggable,
          active: true
        },
        {
          name: 'Dropdowns',
          to: paths.dropdowns,
          active: true
        },
        {
          name: 'List group',
          to: paths.listGroup,
          active: true
        },
        {
          name: 'Modals',
          to: paths.modals,
          active: true
        },
        {
          name: 'Offcanvas',
          to: paths.offcanvas,
          active: true
        },
        {
          name: 'Navs & Tabs',
          active: true,
          children: [
            {
              name: 'Navs',
              to: paths.navs,
              active: true
            },
            {
              name: 'Navbar',
              to: paths.navbar,
              active: true
            },
            {
              name: 'Vertical navbar',
              to: paths.verticalNavbar,
              active: true
            },
            {
              name: 'Top navbar',
              to: paths.topNavbar,
              active: true
            },
            {
              name: 'Double Top',
              to: paths.doubleTopNavbar,
              active: true
            },
            {
              name: 'Combo navbar',
              to: paths.comboNavbar,
              active: true
            },
            {
              name: 'Tabs',
              to: paths.tabs,
              active: true
            }
          ]
        },
        {
          name: 'Pictures',
          active: true,
          children: [
            {
              name: 'Avatar',
              to: paths.avatar,
              active: true
            },
            {
              name: 'Images',
              to: paths.images,
              active: true
            },
            {
              name: 'Figures',
              to: paths.figures,
              active: true
            },
            {
              name: 'Hoverbox',
              to: paths.hoverbox,
              active: true
            },
            {
              name: 'Lightbox',
              to: paths.lightbox,
              active: true
            }
          ]
        },
        {
          name: 'Progress Bar',
          to: paths.progressBar,
          active: true
        },
        {
          name: 'Pagination',
          to: paths.pagination,
          active: true
        },
        {
          name: 'Placeholder',
          to: paths.placeholder,
          active: true
        },
        {
          name: 'Popovers',
          to: paths.popovers,
          active: true
        },
        {
          name: 'Scrollspy',
          to: paths.scrollspy,
          active: true
        },
        {
          name: 'Search',
          to: paths.search,
          active: true
        },
        {
          name: 'Spinners',
          to: paths.spinners,
          active: true
        },
        {
          name: 'Timeline',
          to: paths.timeline,
          active: true
        },
        {
          name: 'Toasts',
          to: paths.toasts,
          active: true
        },
        {
          name: 'Tooltips',
          to: paths.tooltips,
          active: true
        },
        {
          name: 'Treeview',
          to: paths.treeview,
          active: true
        },
        {
          name: 'Typed text',
          to: paths.typedText,
          active: true
        },
        {
          name: 'Videos',
          active: true,
          children: [
            {
              name: 'Embed',
              to: paths.embedVideo,
              active: true
            },
            {
              name: 'React Player',
              to: paths.reactPlayer,
              active: true
            }
          ]
        }
      ]
    },
    {
      name: 'Utilities',
      active: true,
      icon: 'fire',
      children: [
        {
          name: 'Background',
          to: paths.backgroundColor,
          active: true
        },
        {
          name: 'Borders',
          to: paths.borders,
          active: true
        },
        {
          name: 'Colors',
          to: paths.colors,
          active: true
        },
        {
          name: 'Colored links',
          to: paths.coloredLinks,
          active: true
        },
        {
          name: 'Display',
          to: paths.display,
          active: true
        },
        {
          name: 'Flex',
          to: paths.flex,
          active: true
        },
        {
          name: 'Float',
          to: paths.float,
          active: true
        },
        {
          name: 'Grid',
          to: paths.grid,
          active: true
        },
        {
          name: 'Scroll Bar',
          to: paths.scrollBar,
          active: true
        },
        {
          name: 'Position',
          to: paths.position,
          active: true
        },
        {
          name: 'Spacing',
          to: paths.spacing,
          active: true
        },
        {
          name: 'Sizing',
          to: paths.sizing,
          active: true
        },
        {
          name: 'Stretched link',
          to: paths.stretchedLink,
          active: true
        },
        {
          name: 'Text truncation',
          to: paths.textTruncation,
          active: true
        },
        {
          name: 'Typography',
          to: paths.typography,
          active: true
        },
        {
          name: 'Vertical align',
          to: paths.verticalAlign,
          active: true
        },
        {
          name: 'Visibility',
          to: paths.visibility,
          active: true
        }
      ]
    },
    {
      name: 'Widgets',
      icon: 'poll',
      to: paths.widgets,
      active: true
    },
    {
      name: 'Multi level',
      active: true,
      icon: 'layer-group',
      children: [
        {
          name: 'Level two',
          active: true,
          children: [
            {
              name: 'Item 1',
              active: true,
              to: '#!'
            },
            {
              name: 'Item 2',
              active: true,
              to: '#!'
            }
          ]
        },
        {
          name: 'Level three',
          active: true,
          children: [
            {
              name: 'Item 3',
              active: true,
              to: '#!'
            },
            {
              name: 'Item 4',
              active: true,
              children: [
                {
                  name: 'Item 5',
                  active: true,
                  to: '#!'
                },
                {
                  name: 'Item 6',
                  active: true,
                  to: '#!'
                }
              ]
            }
          ]
        },
        {
          name: 'Level four',
          active: true,
          children: [
            {
              name: 'Item 6',
              active: true,
              to: '#!'
            },
            {
              name: 'Item 7',
              active: true,
              children: [
                {
                  name: 'Item 8',
                  active: true,
                  to: '#!'
                },
                {
                  name: 'Item 9',
                  active: true,
                  children: [
                    {
                      name: 'Item 10',
                      active: true,
                      to: '#!'
                    },
                    {
                      name: 'Item 11',
                      active: true,
                      to: '#!'
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};

export const documentationRoutes = {
  label: 'documentation',
  children: [
    {
      name: 'Getting started',
      icon: 'rocket',
      to: paths.gettingStarted,
      active: true
    },
    {
      name: 'Customization',
      active: true,
      icon: 'wrench',
      children: [
        {
          name: 'Configuration',
          to: paths.configuration,
          active: true
        },
        {
          name: 'Styling',
          to: paths.styling,
          active: true
        },
        {
          name: 'Dark mode',
          to: paths.darkMode,
          active: true
        },
        {
          name: 'Plugin',
          to: paths.plugin,
          active: true
        }
      ]
    },
    {
      name: 'Faq',
      icon: 'question-circle',
      to: paths.faq,
      active: true
    },
    {
      name: 'Design file',
      icon: 'palette',
      to: paths.designFile,
      active: true
    },
    {
      name: 'Changelog',
      icon: 'code-branch',
      to: paths.changelog,
      active: true
    }
  ]
};

export default [
  dashboardRoutes,
  //prescriptionRoutes,
  // pagesRoutes,
  // peltaskRoutes,
  // peltaskAdminRoutes
  //reportRoutes
  // hcpRoutes
  /*modulesRoutes,
  documentationRoutes*/
];
